/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconHelp8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M5.261 2.634a.908.908 0 0 0-.224-.334 1.03 1.03 0 0 0-.39-.22 2.54 2.54 0 0 0-.65-.08 2.493 2.493 0 0 0-.65.08 1.03 1.03 0 0 0-.378.217.87.87 0 0 0-.224.333c-.05.142-.076.407-.075.558h.732a1.444 1.444 0 0 1 .026-.294.399.399 0 0 1 .089-.157c.137-.108.266-.154.484-.154.218 0 .342.046.483.157.04.045.078.099.095.157a.652.652 0 0 1 .026.18.561.561 0 0 1-.072.3.83.83 0 0 1-.172.2 1.99 1.99 0 0 1-.224.167c-.084.05-.16.112-.228.183a.954.954 0 0 0-.172.253.92.92 0 0 0-.07.377v.11h.667v-.113a.292.292 0 0 1 .08-.204.883.883 0 0 1 .174-.163l.241-.17c.09-.062.171-.135.244-.217a1.004 1.004 0 0 0 .263-.723 1.292 1.292 0 0 0-.075-.443ZM4.5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.643 1.643a3.333 3.333 0 1 1 4.714 4.714 3.333 3.333 0 0 1-4.714-4.714ZM4 1.333a2.667 2.667 0 1 0 0 5.333 2.667 2.667 0 0 0 0-5.333Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHelp12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M7.892 3.95a1.361 1.361 0 0 0-.337-.5 1.545 1.545 0 0 0-.585-.33A3.81 3.81 0 0 0 5.995 3a3.739 3.739 0 0 0-.976.12 1.546 1.546 0 0 0-.565.326 1.306 1.306 0 0 0-.337.5c-.076.213-.114.61-.112.836h1.097a2.166 2.166 0 0 1 .04-.441.598.598 0 0 1 .133-.235c.206-.162.4-.231.726-.231.327 0 .513.069.724.236a.618.618 0 0 1 .143.235.977.977 0 0 1 .039.27.842.842 0 0 1-.108.45c-.07.113-.157.215-.258.3a2.983 2.983 0 0 1-.337.25 1.63 1.63 0 0 0-.341.275 1.43 1.43 0 0 0-.258.38 1.381 1.381 0 0 0-.105.565V7h1v-.17a.437.437 0 0 1 .12-.305c.084-.094.158-.176.262-.245l.361-.255A2.05 2.05 0 0 0 7.61 5.7a1.507 1.507 0 0 0 .395-1.085 1.938 1.938 0 0 0-.112-.665ZM6.75 8.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.464 2.464a5 5 0 1 1 7.072 7.071 5 5 0 0 1-7.072-7.07ZM6 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHelp16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M10.522 5.268a1.816 1.816 0 0 0-.449-.667 2.06 2.06 0 0 0-.78-.44 5.08 5.08 0 0 0-1.3-.16 4.985 4.985 0 0 0-1.3.16 2.06 2.06 0 0 0-.755.434 1.742 1.742 0 0 0-.449.666c-.101.284-.152.813-.15 1.115h1.464c-.003-.122.014-.472.052-.588a.797.797 0 0 1 .178-.313c.274-.216.533-.308.969-.308.435 0 .684.091.964.314.082.09.156.197.19.314.035.117.052.238.052.36.01.21-.04.418-.143.6a1.66 1.66 0 0 1-.344.4 3.979 3.979 0 0 1-.449.333c-.167.1-.32.224-.455.367-.141.148-.257.32-.345.506-.095.239-.149.496-.139.754v.22h1.333v-.227a.583.583 0 0 1 .043-.22.568.568 0 0 1 .118-.187c.11-.125.21-.235.349-.326l.481-.34c.179-.124.343-.27.488-.434.177-.193.314-.42.405-.669.09-.248.132-.512.121-.777a2.584 2.584 0 0 0-.15-.887ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.286 3.286a6.667 6.667 0 1 1 9.428 9.428 6.667 6.667 0 0 1-9.428-9.428ZM8 2.666a5.333 5.333 0 1 0 0 10.667A5.333 5.333 0 0 0 8 2.667Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHelp20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M13.153 6.585a2.268 2.268 0 0 0-.56-.834 2.574 2.574 0 0 0-.976-.55 6.35 6.35 0 0 0-1.626-.2 6.23 6.23 0 0 0-1.625.2c-.348.111-.67.296-.943.542-.248.229-.44.514-.56.833-.127.355-.19 1.016-.188 1.394h1.83c-.004-.153.018-.59.064-.735a.997.997 0 0 1 .223-.392c.343-.27.666-.385 1.21-.385.545 0 .856.114 1.207.393.101.112.195.246.237.392.043.146.065.298.065.45.012.262-.05.523-.178.75-.117.19-.263.358-.431.5a4.975 4.975 0 0 1-.561.417c-.209.126-.4.28-.569.458-.176.186-.322.4-.43.633-.12.299-.188.62-.175.942v.275h1.667v-.283a.727.727 0 0 1 .053-.274.71.71 0 0 1 .147-.235c.14-.156.263-.293.437-.408l.601-.425c.224-.155.428-.337.61-.542.22-.241.393-.526.506-.836.113-.31.165-.64.152-.972a3.232 3.232 0 0 0-.187-1.108ZM11.25 13.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.108 4.107a8.333 8.333 0 1 1 11.785 11.785A8.333 8.333 0 0 1 4.108 4.107ZM10 3.333a6.667 6.667 0 1 0 0 13.334 6.667 6.667 0 0 0 0-13.334Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHelp24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M15.783 7.902a2.724 2.724 0 0 0-.673-1 3.09 3.09 0 0 0-1.17-.66 7.62 7.62 0 0 0-1.95-.24 7.477 7.477 0 0 0-1.951.24 3.091 3.091 0 0 0-1.132.65 2.612 2.612 0 0 0-.673 1c-.151.426-.227 1.219-.224 1.672h2.194c-.004-.183.023-.708.079-.882.05-.176.145-.337.267-.47.411-.324.8-.462 1.453-.462s1.026.137 1.447.472c.122.133.234.294.285.47.051.175.078.357.078.54.014.315-.06.627-.214.9a2.49 2.49 0 0 1-.517.6c-.213.182-.438.35-.673.5-.25.151-.48.336-.683.55-.211.223-.386.48-.517.76a2.763 2.763 0 0 0-.209 1.13v.33h2v-.34a.874.874 0 0 1 .064-.33c.04-.104.1-.2.176-.28.167-.188.316-.353.524-.49l.722-.51c.268-.186.514-.404.732-.65.265-.29.472-.631.607-1.004a3.07 3.07 0 0 0 .183-1.166 3.88 3.88 0 0 0-.225-1.33ZM13.5 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.929 4.929A10 10 0 1 1 19.07 19.07 10 10 0 0 1 4.93 4.93ZM12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconHelp = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconHelp8 {...iconProps} />;
        case '12':
            return <IconHelp12 {...iconProps} />;
        case '16':
            return <IconHelp16 {...iconProps} />;
        case '20':
            return <IconHelp20 {...iconProps} />;
        case '24':
            return <IconHelp24 {...iconProps} />;
        default:
            return <IconHelp24 {...iconProps} />;
    }
});
